const ANIMATED_SELECTOR = '[data-animate]:not([data-animate="none"])';
const READY_CLASS = 'tooto-entrance-animation-ready';
const IN_CLASS = 'tooto-animate-in';

/** @type {IntersectionObserver | null} */
let observer = null;

/**
 * @param {Element | Document} root
 * @returns {Element[]}
 */
function getAnimatedElements(root = document) {
  const elements = [];

  if (root instanceof Element && root.matches(ANIMATED_SELECTOR)) {
    elements.push(root);
  }

  elements.push(...root.querySelectorAll(ANIMATED_SELECTOR));

  return elements.filter((element) => !element.classList.contains(IN_CLASS));
}

/**
 * @param {Element} element
 */
function revealElement(element) {
  element.classList.add(IN_CLASS);
  observer?.unobserve(element);
}

/**
 * @param {Element | Document} root
 */
function observeEntranceAnimations(root = document) {
  const elements = getAnimatedElements(root);

  if (!elements.length) return;

  document.documentElement.classList.add(READY_CLASS);

  if (!('IntersectionObserver' in window)) {
    elements.forEach(revealElement);
    return;
  }

  observer =
    observer ||
    new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) revealElement(entry.target);
        });
      },
      {
        threshold: 0.15,
      }
    );

  elements.forEach((element) => observer?.observe(element));
}

function initEntranceAnimations() {
  observeEntranceAnimations();

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target instanceof Element) observeEntranceAnimations(event.target);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initEntranceAnimations, { once: true });
} else {
  initEntranceAnimations();
}
